<template>
  <div class="app-main">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"
        :key="key"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive"
      :key="key"></router-view>
  </div>
</template>

<script>
import webService from "@network/webService";
import _ from "lodash";
export default {
  name: "app",
  components: {},
  beforeCreate () { },
  created () {
    this.checkVersion();
  },
  computed: {
    key () {
      return this.$route.fullPath;
    }
  },
  data () {
    return {
      isRouterAlive: true,
      versionKey: 'versionInfo',
      latestVersion: '',
    };
  },
  methods: {
    onClickLeft () {
      this.$router.push("/home");
    },
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    checkVersion () {
      webService.getKeyValueList().then((r) => {
        if (r.data) {
          let versionInfo = _.find(r.data, ["configKey", this.versionKey]);
          if (versionInfo) {
            console.log("version:" + versionInfo.configValue);
            this.latestVersion = versionInfo.configValue;
          }
        }
      });
    }
  },
  provide () {
    return {
      reload: this.reload
    }
  }
};
</script>
<style lang="less">
.app-main {
  //padding-top: 46px;
  overflow: hidden;
  height: 100%;
}

.has-filter {
  color: #c52a1a !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue